import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWRMutation from 'swr/mutation';

export const useLoginTelegram = () => {
  const { trigger } = useSWRMutation('/login/tg', (url, { arg }) =>
    fetcherWithToken(url, {
      method: 'POST',
      body: JSON.stringify(arg),
    })
  );

  return {
    trigger,
  };
};
